import React from 'react';
import bannerImage from '../../../assets/website/images/women.png';
import OutStorySection from './outStory';
import Services from './services';

function WebsiteHomePage() {
  return (
    <main>
      {/* <section className="banner-section ">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="heading-content">
                <div className="heading-1">
                  <h1>Supporting women at every stage, because, babe, it ain’t easy</h1>
                </div>
                <h5 className="h5-headline mt-4 pt-2">Whether you're rising, resting, or rebuilding, we've got your back.</h5>
              </div>
            </div>
            <div className="col-md-6">
              <figure>
                <img src={bannerImage} alt='Supporting women at every stage, because, babe, it ain’t easy' />
              </figure>
            </div>
          </div>
        </div>
      </section> */}
      <section className="about-banner-section section-padding">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text section-head">
              <h1 className="h1-headline">
                Supporting women at every stage, because, babe, it ain’t easy
              </h1>
            </div>
          </div>
        </div>
      </section>
      <OutStorySection />
      <Services />
    </main>
  );
}

export default WebsiteHomePage;
